import styled from 'styled-components'

const MyDiv = styled.div`
.page_heading{
    margin-bottom: 24px;
}
.btn {
    background:rgba(0, 104, 56, 1);
    color:white;
    &:hover{
    background:rgba(0, 104, 56, 1);
    color:white;
  }
}
.flex_header{
    align-items: center;
    justify-content: space-between;
}
.table_header {
    background-color: #f9fafb !important;
  }
 .empId {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    cursor: pointer;
    white-space: nowrap; 
  }
.bdg{
 color: rgba(0, 122, 255, 1);
 background-color: #1E87F033;
 border-radius:4px;
 cursor: pointer;
}
`
export default MyDiv
